export default {
    genericErrorHeader: 'Vi beklager',
    genericErrorText1: 'Vi klarte ikke å tilby denne tjenesten akkurat nå.',
    genericErrorText2:
        'Du kan gå tilbake til forrige steg og prøve igjen. Hvis det fortsatt er feil, så må du dessverre vente en stund. Vi er på saken og prøver å løse feilen så fort som mulig.',
    genericErrorText3: '',
    genericErrorReturnButton: 'Gå tilbake til {productName}',
    genericErrorReturnLink: '/betale/kredittkort',
    genericErrorInfoBox: '{defaultInfoBoxText}',
    genericIframeNotSupportedError: 'Nettleseren din støtter ikke denne visningen',
    genericTryAgain: 'Prøv igjen',
    genericGoBackToCardList: 'Gå til kortoversikten',
    genericErrorNoSuchCard: 'Vi finner ikke noe kort med dette kortnummeret.',
    genericAccountInvalidError: 'Vennligst fyll inn et gyldig kontonummer',
    genericCouldNotFetchUserInfoError: 'Vi fikk ikke hentet din brukerinformasjon.',
};
